module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/design-tile-images/design-tile-02-ad762506ca8098c97eb9234505f4a634.png";